<template>
  <div class="scrollable" v-loading.fullscreen.lock="fullscreenLoading">
  	<v-header></v-header>
    <div class="content"  style="margin-bottom:70px;">
    	<div class="breadNav">
        <p>{{showMsg.relationship===0?$t('m.common.self'):$t('m.common.depend')}}{{$t('m.staffSuccess.brankNav2')}}</p>
      </div>
      <div class="detail">
        <div class="successIcon">
          <p><img src="../../../assets/icon/勾.svg"></p>
          <p>{{$t('m.staffSuccess.tit')}}！</p>
        </div>
        <div class="name">
          <p>{{$t('m.medicalReports.phyPerson')}}：{{showMsg.name}}（{{showMsg.relationship_value}}）</p>
        </div>
        <div class="hospital">
          <p>{{$t('m.phyOrderDetails.hospital')}}：{{getConfirm.confirmMsg.hosNameCheck}}</p>
          <!-- <p >查看机构体检详情</p> -->
          <p @click="getHosMsg" style="color:#FF000F">
            <!-- {{$t('m.phyOrderDetails.getHosDetail')}} -->
            查看机构及分院详情
          </p>
        </div>
        <div class="time">
          <p>{{$t('m.phyOrderDetails.time')}}：{{getConfirm.paramsJSON.exam_date}}</p>
        </div>
        <div class="btns">
          <p @click="getOrderList">{{$t('m.staffSuccess.getOrder')}}</p>
          <p @click="depend" v-if="showMsg.relationship===0">{{$t('m.phyIndex.dependPhyModel')}}</p>
          <p @click="personal" v-else>体检人管理</p>
        </div>
      </div>
      <div class="prompt">
        <h3>{{$t('m.staffSuccess.tips')}}：</h3>
        <div class="front">
          <h4>{{$t('m.staffSuccess.front')}}</h4>
          <p v-for="item in $t('m.staffSuccess.frontMsg')" >{{item}}</p>
        </div>
        <div class="middle">
          <h4>{{$t('m.staffSuccess.middle')}}</h4>
          <p v-for="item in $t('m.staffSuccess.middleMsg')"  >{{item}}</p>
          <!-- <p v-for="item in $t('m.staffSuccess.middleMsg4')" ><span style="display: inline-block;width: 10px;height: 10px;background: #333;border-radius: 50%;margin-right: 10px;margin-left: 9px;"></span> {{item}}</p> -->
          <!-- <p v-for="item in $t('m.staffSuccess.middleMsg5')" >{{item}}</p> -->
        </div>
        <div class="after">
          <h4>{{$t('m.staffSuccess.after')}}</h4>
          <p v-for="item in $t('m.staffSuccess.afterMsg')" >{{item}}</p>
          <!-- <p v-for="item in $t('m.staffSuccess.afterMsg2')" ><span style=" display: inline-block; width: 10px;height: 10px;background: #333;border-radius: 50%;margin-left: 9px;margin-right: 10px;"></span>{{item}}</p>
          <p v-for="item in $t('m.staffSuccess.afterMsg3')">{{item}}</p> -->
        </div>
      </div>
    </div>
    <div id="interpret">
        <el-dialog :visible.sync="interpretVisible" :close-on-click-modal="false">
          <div v-if="hosDetailLoading" style="width: 100%; display: flex; justify-content: center">
            <p style="font-size: 16px; color: #333">{{ $t("m.common.load") }}</p>
          </div>
          <div v-if="!hosDetailLoading" class="interpretMsg">
            <div class="hospitalName">
              <p class="icon"></p>
              <p class="name">
                {{ $t("m.staffHosDetail.hos") }}：{{ datajson.name }}
              </p>
            </div>
            <div class="map" id="XSDFXPage"></div>
            <div class="mapMsg">
              <p>
                <span>{{ $t("m.staffHosDetail.address") }} :</span>
                <span>{{ datajson.address }}</span>
              </p>
              <p>
                <span>{{ $t("m.staffHosDetail.time") }} :</span>
                <span>{{ datajson.work_time }}</span>
              </p>
              <!-- <p><span>{{$t('m.staffHosDetail.phone')}} : </span><span>{{datajson.inst_contact}} </span></p> -->
              <!-- <p>
                <span>{{$t('m.staffHosDetail.msg')}} :</span>
                <span>{{datajson.description}}</span>
              </p>
              <p>
                <span>{{$t('m.staffHosDetail.line')}} :</span>
                <span>{{datajson.traffic_route}}</span>
              </p> -->
            </div>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="interpretVisible=false">{{
                          $t("m.common.closeBtn")
                          }}</el-button>
          </span>
        </el-dialog>
      </div>
  	<v-footer></v-footer>
  </div>
</template>

<script>
    import axios from 'axios';
    import {
        mapActions,
        mapGetters
    } from 'vuex';
    import header from '../../common/header.vue'
    import footer from '../../common/footer.vue'
    export default {
        name: 'success',
        data() {
            return {
                showMsg: {},
                getConfirm: {},
                fullscreenLoading: false,
                interpretVisible: false,
                hosDetailLoading: false,
                datajson: {},
                hosId: null,

            }
        },
        components: {
            "v-header": header,
            "v-footer": footer
        },
        created() {
            let _this = this;
            _this.getConfirm = JSON.parse(sessionStorage.getItem('staffParams'));
            _this.hosId = _this.getConfirm.paramsJSON.hospital
            _this.project = JSON.parse(sessionStorage.getItem("project"));
            _this.fullscreenLoading = true;
            axios.get(BASE_URL + '/exam/relatives/').then((res) => {
                let list = res.data.data;
                list.forEach(function(element) {
                    if (element.id == _this.getConfirm.paramsJSON.relative) {
                        _this.showMsg = element;
                    }
                })
                _this.fullscreenLoading = false;
            }).catch((err) => {
                _this.fullscreenLoading = false;
            })
            console.log(_this.datajson)
        },
        methods: {
            //点击进入个人中心
            personal() {
                let _this = this;
                _this.$router.push({
                    path: '/personal'
                })
            },

            //查看机构详情
            getHosMsg() {
                let _this = this;
                _this.datajson = {};
                _this.interpretVisible = true;
                _this.hosDetailLoading = true;
                //获取机构详情接口
                axios
                    .get(BASE_URL + "/exam/hospitals/" + _this.getConfirm.paramsJSON.hospital + "/", {
                        params: {
                            project: _this.project.id,
                        },
                    })
                    .then((res) => {
                        _this.hosDetailLoading = false;
                        _this.datajson = res.data.data;
                        setTimeout(function() {
                            _this.setMap();
                        }, 100);
                    })
                    .catch((err) => {
                        _this.hosDetailLoading = false;
                    });
            },
            // 地图
            setMap() {
                let _this = this;
                //创建Map实例
                var map = new BMap.Map("XSDFXPage");
                // 初始化地图,设置中心点坐标
                var point = new BMap.Point(
                    parseFloat(_this.datajson.longitude),
                    parseFloat(_this.datajson.latitude)
                ); // 创建点坐标
                map.centerAndZoom(point, 15);
                //添加鼠标滚动缩放
                map.enableScrollWheelZoom();

                //添加缩略图控件
                map.addControl(
                    new BMap.OverviewMapControl({
                        isOpen: false,
                        anchor: BMAP_ANCHOR_BOTTOM_RIGHT,
                    })
                );
                //添加缩放平移控件
                map.addControl(new BMap.NavigationControl());
                //添加比例尺控件
                map.addControl(new BMap.ScaleControl());
                //添加地图类型控件
                //map.addControl(new BMap.MapTypeControl());

                //设置标注的图标
                var icon = new BMap.Icon(
                    require("../../../assets/icon.png"),
                    new BMap.Size(100, 100)
                );
                //设置标注的经纬度
                var marker = new BMap.Marker(
                    new BMap.Point(
                        parseFloat(_this.datajson.longitude),
                        parseFloat(_this.datajson.latitude)
                    ), {
                        icon: icon
                    }
                );
                //把标注添加到地图上
                map.addOverlay(marker);
                var content = "<table>";
                // content = content + "<tr><td> 编号：001</td></tr>";
                content = content + "<tr><td> " + _this.datajson.name + "</td></tr>";
                // content = content + "<tr><td> 时间：2018-1-3</td></tr>";
                content += "</table>";
                var infowindow = new BMap.InfoWindow(content);
                marker.addEventListener("click", function() {
                    _this.openInfoWindow(infowindow);
                });

                //点击地图，获取经纬度坐标
                // map.addEventListener("click",function(e){
                //      document.getElementById("aa").innerHTML = "经度坐标："+e.point.lng+" &nbsp;纬度坐标："+e.point.lat;
                //  });
            },
            //查看订单
            getOrderList() {
                let _this = this;
                _this.$router.push({
                    path: '/phyOrderList',
                    query: {
                        check: 0,
                        statusType: 0
                    }
                })
            },
            //家属体检
            depend() {
                let _this = this;
                axios
                    .get(BASE_URL + "/exam/projects/")
                    .then(res => {
                        _this.fullscreenLoading = false;
                        if (res.data.data.length > 1) {
                            _this.projectVisible = true;
                            _this.projectList = res.data.data;
                        } else {
                            _this.projectList = res.data.data[0];
                            let project = JSON.stringify(_this.projectList);
                            sessionStorage.setItem("project", project);
                            _this.sexRadio = _this.showMsg.gender;
                            if (!_this.showMsg.contacttel) {
                                _this.dialogVisible = true;
                            } else {
                                let family = "";
                                if (_this.name == "dependents") {
                                    family = "&card_type=relative";
                                }
                                let projectId = JSON.parse(sessionStorage.getItem("project")).id;
                                axios
                                    .get(
                                        BASE_URL +
                                        `/exam/relatives/benefit/?project=${projectId}${family}`, {}
                                    )
                                    .then(res1 => {
                                        _this.name == "dependents";
                                        _this.$router.push({
                                            path: "/familyMembers",
                                            query: {
                                                type: "dependents",
                                                batch: res1.data.data.batch,
                                                cardId: res1.data.data.id
                                            }
                                        });
                                    });
                            }
                        }
                    })
                    .catch(err => {
                        _this.fullscreenLoading = false;
                    });
            }
        },
        computed: {
            // ...mapGetters(['phyExPeoList']) // 动态计算属性，相当于this.$store.getters.resturantName
        }
    }
</script>

<style scoped>
    .prompt {
        width: 1180px;
        margin: 0 auto;
        margin-top: 30px;
        margin-bottom: 45px;
    }
    
    .prompt h3 {
        margin-bottom: 23px;
    }
    
    .prompt h4 {
        line-height: 30px;
    }
    
    .prompt h3,
    .prompt h4 {
        font-size: 18px;
        font-weight: 600;
        color: #333;
    }
    
    .prompt p {
        font-size: 18px;
        text-align: justify;
        font-weight: 400;
        color: #333;
        line-height: 30px;
    }
    
    .detail .btns p {
        text-align: center;
    }
    
    .detail .btns {
        margin-left: 369px;
        margin-top: 30px;
        display: flex;
        justify-content: space-between;
        width: 390px;
    }
    
    .detail .btns p:first-child {
        width: 180px;
        height: 46px;
        opacity: 0.34;
        background: #FF000F;
        font-size: 16px;
        font-weight: 600;
        color: #fff;
        line-height: 16px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 23px;
        cursor: pointer;
    }
    
    .detail .btns p:last-child {
        width: 180px;
        height: 46px;
        background: #FF000F;
        font-size: 16px;
        font-weight: 600;
        color: #fff;
        border-radius: 23px;
        line-height: 16px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }
    
    .detail .hospital {
        display: flex;
        align-items: center;
        margin-left: 369px;
        margin-top: 30px;
    }
    
    .detail .hospital p:first-child {
        font-size: 18px;
        font-weight: 600;
        color: #333;
        line-height: 18px;
    }
    
    .detail .hospital p:last-child {
        font-size: 14px;
        font-weight: 400;
        color: #e94709;
        line-height: 16px;
        margin-left: 10px;
        text-decoration: underline;
        cursor: pointer;
    }
    
    .detail .name,
    .detail .time {
        margin-top: 30px;
        display: flex;
        align-items: center;
        margin-left: 369px;
    }
    
    .detail .name p,
    .detail .time p {
        font-size: 18px;
        font-weight: 600;
        color: #333;
        line-height: 18px;
    }
    
    .detail .successIcon {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    
    .detail .successIcon p img {
        width: 58px;
        height: 58px;
    }
    
    .detail .successIcon p:last-child {
        font-size: 24px;
        font-weight: 600;
        color: #333;
        line-height: 24px;
        margin-left: 20px;
    }
    
    .detail {
        width: 1180px;
        margin: 0 auto;
        border: 1px solid #ccc;
        margin-top: 30px;
        padding: 30px;
    }
    
    .breadNav {
        width: 100%;
        height: 80px;
        border-bottom: 2px solid #EAEAEA;
        display: flex;
        align-items: center;
    }
    
    .breadNav p {
        width: 1180px;
        margin: 0 auto;
        font-size: 18px;
        font-weight: 600;
        color: #333;
        line-height: 20px;
    }
    
    .map {
        width: 100%;
        height: 260px;
        border: 1px solid #ccc;
        margin: 0 auto;
        margin-top: 30px;
        padding: 20px;
    }
    
    .map img {
        width: 100%;
        height: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/components/phyExServices/selfPhyExService/successfulAppointment.vue